<template>
  <div class="dof-numcard-row" :style="{ backgroundColor: this._backgroundColor }">
    <slot></slot>
  </div>
</template>

<script>
import { mixParent } from '../utils/mix-parent.js'
import ColmoMixin from '../../mixins/colmo'

export default {
  mixins: [mixParent('dof-row'), ColmoMixin],
  props: {
    borderRightPadding: {
      type: Number,
      default: 32
    },
    borderBottomPadding: {
      type: Number,
      default: 40
    },
    isShowBorderRight: {
      type: Boolean,
      default: true
    },
    isShowBorderBottom: {
      type: Boolean,
      default: false
    },
    isShowDelta: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: ''
    },
    paddingHorizontal: {
      type: {
        type: Number,
        default: 0
      }
    }
  },
  computed: {
    _backgroundColor() {
      if (this.bgColor !== '') return this.bgColor
      return this._isColmo ? '#303237' : '#fff'
    }
  }
}
</script>

<style scoped>
.dof-numcard-row {
  flex-direction: row;
  flex-wrap: nowrap;
  overflow: hidden;
}
@media screen and (weex-theme: colmo) {
  .dof-numcard-row {
    border-radius: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?0ebea1f5